import { createLazyComponent } from '@muse-web/router'

export const AsyncHqDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-hq' */ './HqDialogContainer'),
    'HqDialogContainer',
)
